// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 2V3H16V2H18V3H19V5H18V6.66667L20.5 10H22V12H21V20H22V22H2V20H3V12H2V10H3.5L6 6.66667V5H5V3H6V2H8ZM8 5V6H16V5H8ZM19 12H16V20H19V12ZM14 20V12H10V20H14ZM8 20V12H5V20H8Z"}}]};

const TeahouseFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'teahouse-filled',
    ref,
    icon: element,
  },
));

TeahouseFilledIcon.displayName = 'TeahouseFilledIcon';

export default TeahouseFilledIcon;
